<template>
    <modal :show.sync=show headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Select Property</h3>
        <PropertySelections :is_proposal="true"/>
    </modal>
</template>

<script>
import Modal from "@/components/Modal"
import PropertySelections from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/PropertySelections'

export default {
    props:{
        show_select_property_application: {
            type: Boolean,
            default: false
        },
        bank_code:{
            type: String
        }
    },
    components: {
        PropertySelections,
        Modal
    },
    computed: {
        show: {
            get() {
                return this.show_select_property_application;
            },
            set(newVal) {
                this.$emit('update:show_select_property_application', newVal);
            },
        },
    }
}
</script>
